import { createSlice, Middleware } from "@reduxjs/toolkit"
import { ISessionData } from "./types"

type initialState = {
  response: ISessionData | null
}

export const sessionDataSlice = createSlice({
  name: "sessionData",
  initialState: { response: null } as initialState,
  reducers: {
    setSessionData(state, action) {
      state.response = {
        ...state.response,
        ...action.payload
      }
    }
  }
})

export const { setSessionData } = sessionDataSlice.actions
export default sessionDataSlice.reducer

export const sessionDataHandlerMiddleware: Middleware = () => (next) => (action) => {
  return next(action)
}
